var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paySuccess"},[_c('div',{staticClass:"textBox"},[_c('van-icon',{staticClass:"icon",attrs:{"name":"checked"}}),_c('p',[_vm._v("支付成功")])],1),_c('van-button',{staticClass:"closeBtn",on:{"click":_vm.close}},[_vm._v("关闭")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }